@if (!isLoading) {
<div class="card">
  <div class="card-header">
    Company Information
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label class="control-label">Billing Contact Name</label>
          <input type="text" class="form-control" [formControl]="billingContactNameControl"
            [formValidation]="billingContactNameControl" />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label class="control-label">Billing Contact Email</label>
          <input type="text" class="form-control" [formControl]="billingContactEmailControl"
            [formValidation]="billingContactEmailControl" />
        </div>
      </div>
    </div>
  </div>
  <div class="card-footer">
    <div class="d-flex justify-content-end">
      <button type="button" class="btn btn-success" (click)="save()">Save</button>
    </div>
  </div>
</div>
}